import React, { useEffect, useState } from 'react';
import md5 from 'js-md5';
import userImage from '@/assets/images/login/user.png';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/lock.png';
import msgSuccess from '@/assets/images/login/msgSuccess.png';
import msgHint from '@/assets/images/login/msgHint.png';
import { Form, Input, Button, message } from 'antd';
import classnames from 'classnames';
import { useHistory, withRouter } from 'react-router-dom';
import '../index.less';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import StorageFn from '@/utils/electronStorage';
import {
  LoginHistory,
  LoginForm,
  LOGIN_HISTORY_KEY,
  REPORTED_KEY,
  LOGIN_TRAFFIC_SOURCE_KEY,
  LOGIN_360_PROMOTION_PARAMS_KEY,
  LuthInfoJson,
  LuthInfoData
} from '../types';
import Verify from '../slideVerifyNew';
// import { aliyunSlideProps } from '@/components/Login/typings';
import { apiGetBypassword, apiConfirmBypassword, apiClickBing, apiRegisterReport } from '../server';
import { UserState, setUserInfo } from '@/store/module/user';
import { rsaEncode } from '@/utils/encryption';
import AccountExists from '../dialog';
import { connect } from 'react-redux';
import { IStoreState } from '@/store/types';
import { LoginProps } from '../types';
import Fn from '@/utils/fn';
import { lmessage } from '../message';
import Footer from '../components/footer';
import MewDeviceModal from '../modal/newDeviceModal';
import ConnectModal from '../modal/connectModal';
import UpdateTipModal from '../modal/updateTipModal';
import store from '@/store/index';
import { setBaseTipInfo } from '@/store/baseData/baseTip';
import { loginCollect, loginCollectV3 } from '@/views/login/collect/loginCollect';
import sdk from '@/utils/Buryingpoint';
import { apiGetVersionInfo, apiGetCoreVersion } from '../upgrade/server';
import { apiGetIgnoreLiveByChannel } from '@/views/system/homePage/server';
import yidunSdk from '@/utils/yiDunProtectorWeb';

import YDVerify from '../yidun';
import {
  buryOptsForUid,
  callBaiduBusinessUpload,
  isBaiduBusinessUploadAvailable,
  BaiduBusinessIndustrValue
} from '../baiduBusinessReport';
import {
  setTrafficSourceFromHisId,
  applyBaidu360RetentionOnLogin,
  is360LkPromotionFromHisId,
  getRegisterChannelBuryProps
} from '../loginRetention';
import { getReportHisIdFromSeo, isTrivialPromoReportHisId, normalizePromoLandingSeoOnLogin } from '../promoLanding';

const INDUSTRY_DISPLAY_AD = 'ocpc_zs_convert' as const;
const INDUSTRY_PC_SEARCH = 'ocpc_ps_convert' as const;
const isSatPczsSourceId = (sourceId: string) => sourceId.startsWith('SATpczs');

/** 外壳写入 SEOINFORMATION（REPORTED_KEY）可能晚于页面就绪，分三段延迟同步 */
const REPORTED_KEY_SHELL_SYNC_SCHEDULE_MS = [1200, 450, 450];

const save360PromotionParams = (hisId: string) => {
  const reportHisId = getReportHisIdFromSeo(hisId);
  if (!is360LkPromotionFromHisId(reportHisId)) {
    setLocalStorage(LOGIN_360_PROMOTION_PARAMS_KEY, '');
    return;
  }
  const params = String(reportHisId || '').split('#');
  const sourceId = params[0] || '';
  const idx = params[params.length - 1] || '1';
  const isDisplayAd = params.length >= 5;
  const jzqs = isDisplayAd ? params[3] || '' : '';
  const dataIndustry = jzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
  setLocalStorage(
    LOGIN_360_PROMOTION_PARAMS_KEY,
    JSON.stringify({
      sourceId,
      token360: params[1] || '',
      secret360: params[2] || '',
      jzqs,
      idx,
      data_industry: dataIndustry
    })
  );
};

function LoginAccount(props: LoginProps) {
  const [form] = Form.useForm();
  const [dropStatus, setDropStatus] = useState<boolean>(false);
  const [historyList, setHistoryList] = useState<LoginHistory[]>([]);
  const history: any = useHistory();
  const [showVerify, setShowVerify] = useState<boolean>(false);
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  // const [dialogTitle, setDialogTitle] = useState<string>('');
  // const [dialogContent, setDialogContent] = useState<string | undefined>('');
  const dialogTitle = '';
  const dialogContent = '';
  const [isComposition, setIsComposition] = useState<boolean>(false);
  const [canLogin, setCanLogin] = useState<boolean>(false);
  const [saveFlag, setSaveFlag] = useState<boolean>(false);
  const [hisId, setHisId] = useState<string>('');
  const [modelShow, setModelShow] = useState<boolean>(false);
  const [authInfo, setAuthInfo] = useState<LuthInfoJson>(LuthInfoData);
  const [loginInfo, setLoginInfo] = useState<any>({});
  const msgSuccessImg = <img src={msgSuccess} alt="" />;
  const msgErrorImg = <img src={msgHint} alt="" />;
  const [messageApi, contextHolder] = message.useMessage();
  const [connectModalShow, setConnectModalShow] = useState<boolean>(false);
  const [isCore, setIsCore] = useState<boolean>(false);
  const [updateInfo, setUpdateInfo] = useState<any>();
  const [updateTipModalShow, setUpdateTipModalShow] = useState<boolean>(false);

  useEffect(() => {
    let times = 0;
    let timer = setInterval(() => {
      times += 1;
      if (times > 3) {
        clearInterval(timer);
      }
      if ((window as any).raw && (window as any).raw.heartCall) {
        (window as any).raw.heartCall({ target: 'login' }, (e: any) => {
          clearInterval(timer);
        });
      }
    }, 1000);
  }, []);
  useEffect(() => {
    setHistoryList([]);
    // setTimeout(() => {
    //   StorageFn.electronGetData(LOGIN_HISTORY_KEY).then(res => {
    //     if (res) {
    //       setHistoryList({ ...JSON.parse(res as string) });
    //       changeLoginHistory(0, JSON.parse(res as string));
    //     }
    //   });
    // }, 200);
    store.dispatch(
      setBaseTipInfo({
        visible: false,
        title: '系统提示',
        message: '登录失效，请重新登录',
        saveText: '重新登录'
      })
    );
    const hisArr = getLocalStorage(LOGIN_HISTORY_KEY) ? JSON.parse(getLocalStorage(LOGIN_HISTORY_KEY)) : '';
    if (hisArr && hisArr.length !== 0) {
      setHistoryList(hisArr);
      changeLoginHistory(0, hisArr);
    }
    loginCollect(3100, 1);
    setTimeout(() => {
      loginCollectV3('shebeiqidong_1783', {
        id: localStorage.getItem('deviceIdEle')
      });
    }, 500);
  }, [form]); // eslint-disable-line react-hooks/exhaustive-deps
  /** SEOINFORMATION 由外壳写入；有 gamech 前缀则登录页立即截断落库后再做来源同步 */
  const syncDerivedLoginChannelFromShell = () => {
    const shellHisId = (getLocalStorage(REPORTED_KEY) || '').trim();
    if (shellHisId) {
      const normalizedHisId = normalizePromoLandingSeoOnLogin(shellHisId);
      setHisId(normalizedHisId);
      setTrafficSourceFromHisId(normalizedHisId);
      save360PromotionParams(normalizedHisId);
      return;
    }
    setHisId('');
    setTrafficSourceFromHisId('');
    save360PromotionParams('');
  };
  const reportRegisteredByHisId = (eventParam?: string | null, buryUid?: string | number) => {
    const uidOpts = buryOptsForUid(buryUid);
    const reportHisId = getReportHisIdFromSeo(hisId || getLocalStorage(REPORTED_KEY) || '');
    if (!reportHisId || isTrivialPromoReportHisId(reportHisId)) {
      if (!getLocalStorage(REPORTED_KEY)) {
        setLocalStorage(LOGIN_TRAFFIC_SOURCE_KEY, '');
      }
      return;
    }
    const paramArr = reportHisId.split('#');
    const reportedId = paramArr[paramArr.length - 1] ? paramArr[paramArr.length - 1] : '';
    if (reportedId !== '1') {
      callBaiduBusinessUpload({ newType: 25 }, uidOpts);
      return;
    }
    if (paramArr[1] && paramArr[1] === 'msclk') {
      collectMsclk(paramArr[0], paramArr[2]);
      return;
    }
    if (paramArr[1] && (paramArr[1] === 'yklk' || paramArr[1] === 'sougoulk')) {
      collectYklk(paramArr[0]);
      return;
    }
    if (isSatPczsSourceId(paramArr[0] || '')) {
      const hasJzqs = paramArr.length >= 5 && Boolean(paramArr[3]);
      const industr: BaiduBusinessIndustrValue = hasJzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
      const payload360 = {
        businessInfo: 'REGISTERED',
        businessType: '1',
        industr,
        businessParam: hasJzqs
          ? {
              trans_id: md5(String(Date.now())),
              event_param: eventParam ?? null
            }
          : null
      };
      callBaiduBusinessUpload(payload360, uidOpts);
      return;
    }
    callBaiduBusinessUpload({ businessInfo: 'REGISTERED', businessType: '1', businessParam: null }, uidOpts);
  };
  useEffect(() => {
    let elapsed = 0;
    const timers: ReturnType<typeof setTimeout>[] = [];
    REPORTED_KEY_SHELL_SYNC_SCHEDULE_MS.forEach(ms => {
      elapsed += ms;
      timers.push(setTimeout(() => syncDerivedLoginChannelFromShell(), elapsed));
    });
    return () => timers.forEach(clearTimeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  Window['loginConnectError'] = function () {
    setConnectModalShow(true);
  };
  Window['checkUpgrade'] = function () {
    const versionTxt = localStorage.getItem('appvOrigin');
    const coreVersion = localStorage.getItem('coreVersion');
    apiGetIgnoreLiveByChannel().then(res => {
      const { data } = res;
      localStorage.removeItem('IGNORELIVEBYCHANNEL');
      if (data.live_status === 1) {
        localStorage.setItem('IGNORELIVEBYCHANNEL', '1');
      }
    });

    // 新增 硬盘状态检测 交互
    // 当 硬盘当前为高负荷运行状态时，拉起更新提醒弹窗
    // 点击弹窗取消按钮时，不更新，点击更新时走原来的更新逻辑
    // 如果没返回空的或succes=false，就继续兼容按老的升级
    // ！！！接口会返回当前是否为最新版本，最新版本不需要展示更新弹窗，因此弹窗的调用在接口执行之后
    // console.log('检查硬盘检测方法:', (window as any).raw.getDiskStatus);
    try {
      if ((window as any).raw.getDiskStatus) {
        console.log('开始检测硬盘状态');
        (window as any).raw.getDiskStatus({}, (res: any) => {
          console.log('硬盘状态信息：', res);
          if (res && res.success && (res.isHighLoad || res.loadLevel === 'CRITICAL' || res.loadLevel === 'HIGH')) {
            // res.data.loadLevel: CRITICAL（严重）>HIGH（很高）>ELEVATED（较高）>MODERATE_HIGH（中度偏上）>MODERATE（中度） ，其他NORMAL（正常）
            getVersionInfo(versionTxt as string, coreVersion as string, true);
          } else {
            getVersionInfo(versionTxt as string, coreVersion as string, false);
          }
        });
      } else {
        getVersionInfo(versionTxt as string, coreVersion as string, false);
      }
    } catch (error) {
      console.error('硬盘检测方法不存在', error);
    }
  };

  const getVersionInfo = (versionTxt: string, coreVersion: string, isHighLoad: boolean) => {
    // isHighLoad：用以校验当前硬盘状态
    // false（走原逻辑），true（获取并保存更新需要的数据，但不进行更新页面的路由跳转）
    apiGetVersionInfo({
      app_version: versionTxt
    }).then(res => {
      const data: any = res.data;
      setUpdateInfo(data ? data : {});
      setIsCore(false);
      if (data.cur_info && (data.cur_info.app_status === 1 || data.cur_info.app_status === 2)) {
        if (isHighLoad) {
          localStorage.setItem('useGetDiskStatusType', '1');
          setUpdateTipModalShow(true);
        } else {
          history.push('/login/upgrade', { isCore: false, res: data });
        }
        return;
      }
      if (data.new_info && (data.new_info.app_status === 1 || data.new_info.app_status === 2)) {
        if (isHighLoad) {
          localStorage.setItem('useGetDiskStatusType', '2');
          setUpdateTipModalShow(true);
        } else {
          history.push('/login/upgrade', { isCore: false, res: data });
        }
        return;
      }
      apiGetCoreVersion({
        app_version: coreVersion
      }).then(cres => {
        setUpdateInfo(cres.data ? cres.data : {});
        setIsCore(true);
        if (
          cres &&
          cres.data &&
          cres.data.new_info &&
          (cres.data.new_info.app_status === 1 || cres.data.new_info.app_status === 2)
        ) {
          if (isHighLoad) {
            localStorage.setItem('useGetDiskStatusType', '3');
            setUpdateTipModalShow(true);
          } else {
            history.push('/login/upgrade', { isCore: true, res: cres.data });
          }
          return;
        }
        localStorage.setItem('warningUpload', JSON.stringify({}));
      });
    });
  };

  function modalUpdate(flag: boolean) {
    localStorage.setItem('useGetDiskStatusType', '4');
    setUpdateTipModalShow(flag);
    if (flag) {
      // 根据硬盘弹窗操作进行更新
      history.push('/login/upgrade', { isCore: isCore, res: updateInfo });
    }
  }

  function formSubmit() {
    loginCollect(3103, 2);
    form.validateFields().then(res => {
      let formData = res as LoginForm;
      formData.password = formData.password?.trim();
      formData.username = formData.username?.trim();
      if (!formData.username || formData.username?.length < 6) {
        return lmessage.error('账号字符不得低于6位');
      }
      if (!formData.password || formData.password.length < 6) {
        return lmessage.error('密码字符不得低于6位');
      }
      // if (!formData.policy) {
      //   return lmessage.error('请先勾选同意《用户授权议》、《隐私条款》');
      // }
      // setShowVerify(true);
      slideChange();
    });
  }
  function setStorage(userinfo: LoginForm) {
    let isRepeat = false;
    let listIndex = 0;
    for (let i = 0, len = historyList.length; i < len; i += 1) {
      if (historyList[i].username === userinfo.username) {
        listIndex = i;
        isRepeat = true;
        break;
      }
    }
    if (!isRepeat) {
      historyList.unshift(userinfo);
    } else {
      historyList.splice(listIndex, 1);
      historyList.unshift(userinfo);
    }
    setHistoryList(historyList);
    StorageFn.electronSetData(LOGIN_HISTORY_KEY, JSON.stringify(historyList));
    setLocalStorage(LOGIN_HISTORY_KEY, JSON.stringify(historyList));
  }
  function delStorage(index: number) {
    let temp = [];
    for (let i = 0, len = historyList.length; i < len; i += 1) {
      if (index !== i) {
        temp.push(historyList[i]);
      }
    }
    setHistoryList(temp);
    StorageFn.electronSetData(LOGIN_HISTORY_KEY, JSON.stringify(temp));
    setLocalStorage(LOGIN_HISTORY_KEY, JSON.stringify(temp));
  }
  const onSave = () => {
    let formData = form.getFieldsValue();
    formData.save = !formData.save;
    form.setFieldsValue({ ...formData });
    setSaveFlag(formData.save);
  };
  const changeLoginHistory = (index: number, data: any) => {
    let formData = form.getFieldsValue();
    formData.password = data[index].password;
    formData.username = data[index].username;
    formData.save = data[index].save;
    setSaveFlag(data[index].save);
    form.setFieldsValue({ ...formData });
    setCanLogin(true);
    setDropStatus(false);
  };
  const selectLogin = () => {
    setDropStatus(!dropStatus);
  };
  const accountHide = () => {
    setDropStatus(false);
  };
  function backChange() {
    setShowVerify(false);
  }
  const collectMsclk = async (msclkId: string, bindType: string) => {
    const res = await apiClickBing({
      type: 2,
      clickId: msclkId,
      deviceId: '',
      bingType: bindType
    });
    console.log(res, 111);
  };
  const collectYklk = async (id: string) => {
    const res = await apiRegisterReport({
      clickId: id
    });
    console.log(res, 111);
  };
  const onConfirmBy = (verifyType: number) => {
    const autoObj = {
      ...loginInfo,
      loginAuthType: authInfo.loginAuthType,
      loginVerifyType: verifyType === 1 ? 'PHONE_CODE' : 'EMPOWER'
    };
    apiConfirmBypassword({ ...autoObj })
      .then(({ data }: { data: UserState }) => {
        if (data.code && (data.code === 20045 || data.code === 20010 || data.code === 20041)) {
          // setDialogTitle('登录失败');
          // return setDialogVisible(true);
          lmessage.error(data.msg ? data.msg : '登录失败');
          return setShowVerify(false);
        }
        if (!data.data?.bind_phone_token) {
          customMsg(1, '登录成功');
          loginCollect(3106, 1);
          if (data.userInfo) data.userinfo = data.userInfo;
          const res: any = data;
          if (res.userinfo.is_register !== 0) {
            sdk.Burying({
              uid: res.userinfo.id,
              eventname: 'user_register',
              eventtype: 'track',
              properities: getRegisterChannelBuryProps(hisId)
            });
            if (isBaiduBusinessUploadAvailable()) {
              reportRegisteredByHisId(undefined, res.userinfo.id);
            }
          } else {
            sdk.Burying({
              uid: res.userinfo.id,
              eventname: 'user_login',
              eventtype: 'track'
            });
          }
          applyBaidu360RetentionOnLogin(hisId, res.userinfo.id);
          delete data.userInfo;
          props.setUserInfo(data);
          Fn.getByRefresh(true, () => {
            message.destroy();
          });
        } else {
          lmessage.error('请绑定手机号');
          history.push('/login/bindPhone', { bind_phone_token: data.data?.bind_phone_token, type: 'account' });
        }
        // utils.openMain();
      })
      .catch(e => {
        setShowVerify(false);
      });
    setModelShow(false);
  };
  const slideChange = () => {
    // const slideChange = (params: aliyunSlideProps) => {
    let formData = form.getFieldsValue();
    let loginInfoType: any = {
      loginInfo: rsaEncode(JSON.stringify({ username: formData.username, password: formData.password })),
      channel_id: '',
      game_id: '',
      inviter_uid: '',
      needConfirmLogin: true
    };
    apiGetBypassword({ ...loginInfoType })
      .then(({ data }: { data: UserState }) => {
        if (data.code && (data.code === 20045 || data.code === 20010 || data.code === 20041)) {
          // setDialogTitle('登录失败');
          // return setDialogVisible(true);
          lmessage.error(data.msg ? data.msg : '登录失败');
          return setShowVerify(false);
        }
        const authObj: any = data.data;
        if (data.code && data.code === 20088) {
          const authData = {
            account: formData.username,
            loginAuthType: authObj.loginAuthType ? authObj.loginAuthType : '',
            token: authObj.token ? authObj.token : '',
            authOpenStatus: authObj.authOpenStatus ? authObj.authOpenStatus : false
          };
          console.log(authData);
          setAuthInfo({ ...authData });
          setLoginInfo(loginInfoType);
          setModelShow(true);
        }
        // TODO 去登录
        if (!data.data?.bind_phone_token) {
          loginCollect(3106, 1);
          yidunSdk.yiDunProtector('2');
          if (data.userInfo) data.userinfo = data.userInfo;
          const res: any = data;
          if (res.userinfo.is_register !== 0) {
            sdk.Burying({
              uid: res.userinfo.id,
              eventname: 'user_register',
              eventtype: 'track',
              properities: getRegisterChannelBuryProps(hisId)
            });
            if (isBaiduBusinessUploadAvailable()) {
              reportRegisteredByHisId(undefined, res.userinfo.id);
            }
          } else {
            sdk.Burying({
              uid: res.userinfo.id,
              eventname: 'user_login',
              eventtype: 'track'
            });
            // sdk.Burying({
            //   uid: res.userinfo.id,
            //   eventname: 'login_home',
            //   eventtype: 'track'
            // });
          }
          applyBaidu360RetentionOnLogin(hisId, res.userinfo.id);
          if (!formData.save) {
            formData.password = '';
          }
          setStorage(formData);
          delete data.userInfo;
          props.setUserInfo(data);
          lmessage.loading('登录中…');
          Fn.getByRefresh(true, () => {
            message.destroy();
          });
        } else {
          lmessage.error('请绑定手机号');
          history.push('/login/bindPhone', { bind_phone_token: data.data?.bind_phone_token, type: 'account' });
        }
        // utils.openMain();
      })
      .catch(e => {
        console.log(e);
        setShowVerify(false);
      });
  };

  const handleComposition = (e: any) => {
    if (e.type === 'compositionend') {
      setIsComposition(false);
    } else {
      setIsComposition(true);
    }
  };

  function changeStatus() {
    const formData = form.getFieldsValue();
    if (formData.username && formData.password) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  }

  function setPass(e: any) {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      username: value.replace(/[\W]/g, '')
    });
    let formData = form.getFieldsValue();
    formData.password = '';
    if (value.length >= 6) {
      for (let i = 0, len = historyList.length; i < len; i += 1) {
        if (historyList[i].username === value && historyList[i].save) {
          formData.password = historyList[i].password;
          break;
        }
      }
    }
    form.setFieldsValue(formData);
    changeStatus();
  }

  const handlePercentMatchPwd = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      password: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  const footerBtnChange = (params: string) => {
    setShowVerify(false);
    setDialogVisible(false);
    return;
  };
  const focus = () => {
    loginCollect(3101, 3);
  };
  const getFocus = () => {
    loginCollect(3102, 3);
  };
  const onGoBack = () => {
    history.push('/login/phone');
    loginCollect(3105, 2);
  };
  const customMsg = (type: number, msgText: string) => {
    message.destroy();
    messageApi.open({
      type: 'success',
      content: msgText,
      icon: type === 1 ? msgSuccessImg : msgErrorImg,
      className: 'login-custom-messages-class',
      style: {
        marginTop: '15vh'
      }
    });
  };
  const onServiceChange = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation();
    if ((window as any).raw) {
      (window as any).raw.openExternalBrower({ url: 'https://qiyukf.com/client?k=068326698127e91dffa741e2f6725199' });
    }
    // window.open('https://qiyukf.com/client?k=068326698127e91dffa741e2f6725199');
  };
  return (
    <div onClick={() => accountHide()}>
      <div className="login-switch_mold">
        <div className="currnt">账号登录</div>
        <div className="separate"></div>
        <div
          onClick={e => {
            e.stopPropagation();
            onGoBack();
          }}
        >
          短信登录
        </div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <div className="login_username_box">
            <Form.Item name="username" initialValue="">
              <Input
                placeholder="996游戏账号 / 盒子号"
                onCompositionStart={handleComposition}
                onCompositionEnd={handleComposition}
                onKeyUp={event => setPass(event)}
                onFocus={() => focus()}
                maxLength={20}
                allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
                prefix={<img className="password_icon" src={userImage} alt="" />}
                suffix={
                  <span
                    className={classnames('password_icon history_icon', { down: dropStatus !== true })}
                    onClick={e => {
                      e.stopPropagation();
                      selectLogin();
                    }}
                  ></span>
                }
              ></Input>
            </Form.Item>
            {dropStatus === true && historyList.length !== 0 ? (
              <ul className="accout_item accout__select_item">
                {historyList.map((item: LoginHistory, index: number) => (
                  <li key={index} onClick={() => changeLoginHistory(index, historyList)}>
                    <span>{item.username}</span>
                    <span
                      className="close"
                      onClick={e => {
                        e.stopPropagation();
                        delStorage(index);
                      }}
                    ></span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
          <Form.Item name="password" initialValue="">
            <Input.Password
              placeholder="请输入密码"
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchPwd(event)}
              onFocus={() => getFocus()}
              maxLength={20}
              iconRender={visible => {
                return (
                  <div>
                    {!visible ? (
                      <span className="password_icon password_hide_icon"></span>
                    ) : (
                      <span className="password_icon password_show_icon"></span>
                    )}
                  </div>
                );
              }}
              prefix={<img className="password_icon" src={luckImage} alt="" />}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
            ></Input.Password>
          </Form.Item>
          <div className="check_lines">
            <div className="check_lines_right checkbox_pwd_rights checkbox_pwd_box" style={{ marginBottom: '24px' }}>
              <div
                className="check_lines_right_checkbox"
                onClick={e => {
                  e.stopPropagation();
                  onSave();
                }}
              >
                <Form.Item name="save" valuePropName="checked" initialValue={false}>
                  <input type="checkbox" className="login-clauseCheckbox" />
                </Form.Item>
                <span className="save_checked_text" style={{ color: saveFlag ? '#FFCC33' : '' }}>
                  记住密码
                </span>
              </div>
              <div className="check_lines_right_btn">
                <span onClick={e => onServiceChange(e)}>客服咨询</span>
                <div className="separate separates"></div>
                <span
                  onClick={e => {
                    e.stopPropagation();
                    history.replace('/login/signup');
                  }}
                >
                  注册
                </span>
                <div className="separate separates"></div>
                <span
                  onClick={e => {
                    e.stopPropagation();
                    history.push('/login/forgot');
                  }}
                >
                  忘记密码
                </span>
              </div>
            </div>
          </div>
          {!showVerify ? null : <Verify backChange={backChange} slideChange={slideChange} registerStatus={2}></Verify>}
          <YDVerify></YDVerify>
          <Button
            htmlType="submit"
            className={canLogin ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
            style={{ display: showVerify ? 'none' : 'block' }}
          >
            登录
          </Button>
        </Form>
      </div>
      <Footer agreementType={1}></Footer>
      <AccountExists
        visible={dialogVisible}
        visableTitle={dialogTitle}
        current={0}
        visableHint={dialogContent}
        footerBtnChange={footerBtnChange}
      ></AccountExists>
      {modelShow ? (
        <MewDeviceModal
          modelShow={modelShow}
          setModelShow={setModelShow}
          authInfo={authInfo}
          onConfirmBy={onConfirmBy}
          customMsg={customMsg}
        />
      ) : null}
      {contextHolder}
      {connectModalShow ? (
        <ConnectModal connectModelShow={connectModalShow} setConnectModelShow={setConnectModalShow} />
      ) : null}
      {updateTipModalShow ? <UpdateTipModal updateTipModalShow={updateTipModalShow} modalUpdate={modalUpdate} /> : null}
    </div>
  );
}

const mapStateToProps = ({ settings }: IStoreState) => ({ settings });
const mapDispatchToProps = { setUserInfo };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginAccount));
